import { RefList } from '../model/ref-list';

export enum Role {
  visitor = 'visitor',
  contributor = 'contributor',
  assessmentManager = 'assessmentManager',
  manager = 'manager',
  admin = 'admin',
}
export const listRole: RefList<Role>[] = [
  {
    key: Role.manager,
    value: 'Administrateur',
    des: 'Administrateur Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
  {
    key: Role.assessmentManager,
    value: "Gestionnaire d'évaluation",
    des: "Gestionnaire d'évaluation Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  },
  {
    key: Role.contributor,
    value: 'Contributeur',
    des: 'Contributeur Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  },
];
